import { createAsyncThunk } from "@reduxjs/toolkit";
import { companyService } from "@/shared/services/api/company-service";
import { IGetCompanyMembersParams } from "../types/company-member";

export const getCompanyMembersThunk = createAsyncThunk(
  "companyMember/getCompanyMembers",
  async (params: IGetCompanyMembersParams, thunkAPI) => {
    try {
      const response = await companyService.getCompanyMembers(params);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Şirket üyeleri alınırken hata oluştu");
    }
  }
); 